export default "#### Use my own funds\n\nPay the full purchase amount for faster delivery.\n";